import EngagementStatisticsNav from 'components/Dashboard/Influence/InfluenceCrmSubNav/components/EngagementStatisticsNav';
import LobbyingMaterialSubnav from 'components/Dashboard/Influence/InfluenceCrmSubNav/components/LobbyingMaterialSubnav';
import { useLocation } from 'react-router';

const BriefPolicymakersSubnav = () => {
  const location = useLocation();
  const innerPath = location.pathname.split('/')[2];

  return (
    <div className={`contact-crm-subnav inbox-items-bar monitor-items-bar trends-subnav-bar crm-contacts-subnav-bar`}>
      <div className='mx-auto main-content-wrapper flex-centered justify-content-between'>
        <div className='side-left-element pl-md-5 pl-3 d-none d-lg-block'>
          <p className='mb-0 title-h4 nowrap-item influence-subnav-tab-title'>
            <>Brief policymakers</>
          </p>
        </div>

        <div
          className={`main-content flex-centered  filters-general-container justify-content-between pr-xl-5 px-md-4 px-3`}
        >
          {innerPath?.includes('engagement-statistics') && <EngagementStatisticsNav />}
          {innerPath?.includes('lobbying-material') && <LobbyingMaterialSubnav />}
        </div>
      </div>
    </div>
  );
};

export default BriefPolicymakersSubnav;
